import React, { useState, useEffect } from "react";
import {
  Container,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
  Box,
  CircularProgress,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useNavigate } from "react-router-dom";
import { investorApi } from "../api/api";
import { useSelector } from "react-redux";
import GradientButton from "../components/common/GradiantButton";
import Loader from "../components/common/Loader";

const Help = () => {
  const navigate = useNavigate();
  const [expanded, setExpanded] = useState(null);
  const [faqs, setFaqs] = useState([]);
  const [loading, setLoading] = useState(true);
  const theme=useSelector((data)=>data.themeValue.colors)

  useEffect(() => {
     window.scrollTo({ top: 0, behavior: "smooth" });
    const fetchFAQs = async () => {
      try {
        const response = await investorApi.getFAQs();
        if (response.status === 200) {
          setFaqs(response.data);
        } else {
          console.warn("Unexpected API response:", response.data);
        }
      } catch (err) {
        console.error("API Fetch Error:", err);
      } finally {
        setLoading(false);
      }
    };

    fetchFAQs();
  }, []);

  const handleAccordionChange = (panelId) => (event, isExpanded) => {
    setExpanded(isExpanded ? panelId : null);
  };

  return (
    <Container maxWidth="md" sx={{ mt: 6 }}>
      <Typography
        variant="h4"
        fontWeight="bold"
        gutterBottom
        sx={{ textAlign: "center", mb: 4,color:theme.text }}
      >
        Frequently Asked Questions
      </Typography>
      {loading ? (
        <Loader/>
      ) : (
       
        faqs.map((item) => (
          <Accordion
            key={item.id}
            expanded={expanded === item.id}
            onChange={handleAccordionChange(item.id)}
            sx={{ mb: 2,backgroundColor:theme.background }}
          >
            <AccordionSummary expandIcon={<ExpandMoreIcon sx={{color:theme.text}} />}>
              <Typography fontWeight="bold" sx={{color:theme.text}}>{item.question}</Typography>
            </AccordionSummary>
            <AccordionDetails>
              <Typography sx={{color:theme.text}}>{item.answer}</Typography>
            </AccordionDetails>
          </Accordion>
        ))
      )}
      <Box sx={{ textAlign: "center", mt: 5 }}>
        <GradientButton text="Send Message" 
        width={{lg:"25%",xs:"50%",sm:"50%"}}
        onClick={() => navigate("/SendMessage")}
        />
      </Box>
    </Container>
  );
};

export default Help;
